import { IButton } from '../../interfaces/interfaces';
import './Button.scss';


import React from 'react';
import LocalizedLink from './LocalizedLink';

Button.defaultProps = {
    link: null,
    label: ``,
    className: ``,
    form: null,
    icon: ``,
    iconRight: ``,
    disabled: false,
    state: null,
};

function Label(props: any) {
    const text = props.children || props.label;

    return (
        <>
            {props.icon && <img src={props.icon} alt='' />}
            {/* props.icon && <object type='image/svg+xml' data={props.icon} /> */}
            {text && <span>{text}</span>}
            {props.iconRight && (
                <img
                    className={`iconRight`}
                    src={props.iconRight}
                    alt={props.iconRight}
                />
            )}
        </>
    );
}

export default function Button(props: IButton) {
    if (props.link) {
        return (
            <LocalizedLink
                to={props.link}
                className={`button ${props.className}`}
                state={props.state}
            >
                <Label {...props} />
            </LocalizedLink>
        );
    } else {
        const disabled = props.disabled ? 'disabled' : '';
        return (
            <button
                disabled={props.disabled || false}
                onClick={(e) => props.onClick && props.onClick(e)}
                onMouseEnter={(e) =>
                    props.onMouseEnter && props.onMouseEnter(e)
                }
                onMouseLeave={(e) =>
                    props.onMouseLeave && props.onMouseLeave(e)
                }
                className={`button ${props.className} ${disabled}`}
                form={props.form}
            >
                <Label {...props} />
            </button>
        );
    }
}
